export { TaxonomyModalTabs } from "./TaxonomyModalTabs";
